export default {
  root: {
    color: '#66788A',
    minWidth: '32px'
  }
};
